<!--
 * @Author: your name
 * @Date: 2021-11-24 23:38:21
 * @LastEditTime: 2021-11-30 14:14:43
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /static-pc/src/views/about/About.vue
-->
<template>
  <div class="container">
    <Nav/>
    <div>
      <img :src="require('@/assets/about/about_banner.png')" class="about-image" alt="">
    </div>
    <div class="cover-wrapper">
      <img :src="require('@/assets/about/about_team.png')" class="about-image" alt="">
      <video class="video-wrapper" muted controls autoplay loop src="http://1500008056.vod2.myqcloud.com/4385c223vodtranscq1500008056/30f80f7b387702292180557749/v.f100040.mp4"></video>
    </div>
    <div>
      <img :src="require('@/assets/about/about_fix.png')" class="about-image" alt="">
    </div>
    <div class="about-text">
      <div>我们致力于通过移动互联网</div>
      <div>实现优质医药信息0.1秒精准传递到临床一线，打破医学信息传递的不对称</div>
      <div>促使好产品获得好回报，进而加速医药研发创新</div>
      <div>推动民族医药产业实现弯道超车</div>
      <div>降低因为健康问题而产生的社会成本！</div>
    </div>
  </div>
</template>
<script>
import Nav from '@/layout/Nav'
export default {
  name: 'About',
  components: {
    Nav
  }
}
</script>
<style lang="scss" scoped>
  .container {
    padding-top: 15px;
    position: relative;
    min-width: 1280px;
  }
  .about-image  {
    max-width: 1920px;
    width: 100%;
  }
  .about-text {
    position: absolute;
    text-align: center;
    color: #787878;
    font-size: 20px;
    line-height: 38px;
    bottom: 0;
    left: 50%;
    transform: translate3d(-50%,-5vw,0);
  }
  .cover-wrapper {
    position: relative;
    padding-bottom: 100px;
  }
  .video-wrapper {
    width: 54.17vw;
    background-color: #EEEEEE;
    position: absolute;
    left: 50%;
    top: 100%;
    transform: translate3d(-50%,-110px,0);
  }
</style>